import { selfCostAccounts } from '@/utils/accounts/self-cost-accounts.ts';
import type { BaseColumnData } from '@/utils/tables/column-data';
import {
  type ForecastData,
  ForecastDetailData,
  type Nullish,
  SubForecastData,
} from 'cesg-shared';

export interface ForecastColumnData extends BaseColumnData {
  key: keyof ForecastData | '' | 'actions';
}

export interface SubForecastColumnData extends BaseColumnData {
  key: keyof SubForecastData | '' | 'actions';
}

export interface ForecastDetailColumnData extends BaseColumnData {
  key: keyof ForecastDetailData | '' | 'actions';
}

export function getDangerStyleWhenPositive(value: Nullish<string | number>) {
  if (value === undefined || value === null || value === '') {
    return '';
  }
  return Number(value) > 0 ? 'has-text-danger' : '';
}

export function getDangerStyleWhenNegative(value: Nullish<string | number>) {
  if (value === undefined || value === null || value === '') {
    return '';
  }
  return Number(value) < 0 ? 'has-text-danger' : '';
}

export function editResultForAccount(account: Nullish<number>): boolean {
  if (account === undefined || account === null) {
    return false;
  }
  const accountNumber = Number(account);
  return !isNaN(accountNumber) && selfCostAccounts.includes(accountNumber);
}
